import { useRequest } from 'ahooks';
import { useEffect, useState } from 'react';
import {
  changeRuleService,
  changeSysParamService,
  getLevelService,
  getRuleService,
  getSysParamService,
} from './services';

export default function SysParamMgrModal() {
  const [securityRuleVisible, setSecurityRuleVisible] =
    useState<boolean>(false); // 控制安全规则弹窗

  const [changeBtnVisible, setChangeBtnVisible] = useState(false); // 修改 / 保存按钮切换展示
  const [sysparamList, setSysparamList] = useState<any[]>([]); // 系统列表数据

  const {
    loading: sysparamLoading,
    data: sysparamData,
    run: querySysparam,
    refresh,
  } = useRequest(getSysParamService, {
    manual: true,
  });

  const { data: levelData, run: queryLevel } = useRequest(getLevelService, {
    manual: true,
  });

  const {
    loading: securityRuleLoading,
    data: ruleData,
    run: queryRule,
  } = useRequest(getRuleService, {
    manual: true,
  });

  const { runAsync: changeSysParam } = useRequest(changeSysParamService, {
    manual: true,
  });

  const { loading: changeRuleLoading, runAsync: changeRule } = useRequest(
    changeRuleService,
    {
      manual: true,
    },
  );

  useEffect(() => {
    setSysparamList(sysparamData);
  }, [sysparamData]);

  return {
    levelData,
    ruleData,
    sysparamData,
    securityRuleVisible,
    securityRuleLoading,
    sysparamLoading,
    changeRuleLoading,
    sysparamList,
    changeBtnVisible,
    queryLevel,
    queryRule,
    querySysparam,
    changeSysParam,
    changeRule,
    setSecurityRuleVisible,
    setChangeBtnVisible,
    setSysparamList,
    refresh,
  };
}
